import $ from "jquery";
import slick from "slick-carousel";

export default () => {
  $(".card-slider").slick({
    slidesToShow: 1,
    fade: true,
    arrows: false,
    dots: false,
    asNavFor: ".card-thumbs",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true
        }
      }
    ]
  });
  
  $(".card-thumbs").slick({
    slidesToShow: 5,
    arrows: true,
    nextArrow: `
    <div class="slick-arrow slick-arrow--next">
    <svg class="slick-arrow__svg"><use xlink:href="/images/sprite.svg#arrow-next"/></svg>
    </div>`,
    prevArrow: `
    <div class="slick-arrow slick-arrow--prev">
    <svg class="slick-arrow__svg"><use xlink:href="/images/sprite.svg#arrow-prev"/></svg>
    </div>`,
    asNavFor: ".card-slider",
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1680,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 5
        }
      }
    ]
  });
  
  $(".insert-slider").slick({
    slidesToShow: 3,
    arrows: true,
    nextArrow: `
    <div class="slick-arrow slick-arrow--next">
    <svg class="slick-arrow__svg"><use xlink:href="/images/sprite.svg#arrow-next"/></svg>
    </div>`,
    prevArrow: `
    <div class="slick-arrow slick-arrow--prev">
    <svg class="slick-arrow__svg"><use xlink:href="/images/sprite.svg#arrow-prev"/></svg>
    </div>`,
    responsive: [
      {
        breakpoint: 1199,
        settings: {}
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 413,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });
  
  $(".history-numbers").slick({
    slidesToShow: 7,
    arrows: true,
    
    nextArrow: `
    <div class="slick-arrow slick-arrow--next">
    <svg class="slick-arrow__svg"><use xlink:href="/images/sprite.svg#arrow-next"/></svg>
    </div>`,
    prevArrow: `
    <div class="slick-arrow slick-arrow--prev">
    <svg class="slick-arrow__svg"><use xlink:href="/images/sprite.svg#arrow-prev"/></svg>
    </div>`,
    asNavFor: ".history-slider",
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 4,
          centerMode: false
        }
      },
      {
        breakpoint: 760,
        settings: "unslick"
      }
    ]
  });
  
  $(".history-slider").slick({
    slidesToShow: 1,
    fade: true,
    arrows: false,
    dots: false,
    asNavFor: ".history-numbers",
    responsive: [
      {
        breakpoint: 800,
        settings: {
          dots: true,
          arrows: true,
          nextArrow: `<div class="slick-arrow slick-arrow--next-h"> <svg class="slick-arrow__svg"><use xlink:href="/images/sprite.svg#arrow-next"/></svg></div>`,
          prevArrow: `<div class="slick-arrow slick-arrow--prev-h"><svg class="slick-arrow__svg"><use xlink:href="/images/sprite.svg#arrow-prev"/></svg></div>`,
        }
      }
    ]
  });
  
  $(".partners-slider").slick({
    slidesToShow: 6,
    nextArrow: `
    <div class="slick-arrow slick-arrow--next">
    <svg class="slick-arrow__svg"><use xlink:href="/images/sprite.svg#arrow-next"/></svg>
    </div>`,
    prevArrow: `
    <div class="slick-arrow slick-arrow--prev">
    <svg class="slick-arrow__svg"><use xlink:href="/images/sprite.svg#arrow-prev"/></svg>
    </div>`,
    responsive: [
      {
        breakpoint: 1680,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: true
        }
      }
    ]
  });
  
  $(".advantages-slider").slick({
    slidesToShow: 3,
    arrows: true,
    
    prevArrow: $(".advantages-slider__arrow--prev"),
    nextArrow: $(".advantages-slider__arrow--next"),
    
    dots: false,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    centerMode: true,
    speed: 1000,
    centerPadding: 0,
    asNavFor: ".advantages-slideshow",
    responsive: [
      {
        breakpoint: 760,
        settings: "unslick"
      }
    ]
  });
  
  $(".advantages-slideshow").slick({
    slidesToShow: 1,
    arrows: false,
    dots: false,
    vertical: true,
    speed: 1000,
    asNavFor: ".advantages-slider",
    responsive: [
      {
        breakpoint: 760,
        settings: {
          vertical: false,
          dots: true
        }
      }
    ]
  });
  
  // const slide11 = $(".advantages-slider .slick-active")[0];
  // const slide22 = $(".advantages-slider .slick-active")[1];
  // const slide33 = $(".advantages-slider .slick-active")[2];
  // const slide44 = $(".advantages-slider .slick-active")[3];
  // const slide55 = $(".advantages-slider .slick-active")[4];
  // $(slide11).addClass('slick-active--1');
  // $(slide22).addClass('slick-active--2');
  // $(slide33).addClass('slick-active--3');
  // $(slide44).addClass('slick-active--2');
  // $(slide55).addClass('slick-active--1');
  
  // $(".advantages-slider").on('beforeChange', () => {
  //   const slide1 = $(".advantages-slider .slick-active")[0];
  //   const slide2 = $(".advantages-slider .slick-active")[1];
  //   const slide3 = $(".advantages-slider .slick-active")[2];
  //   const slide4 = $(".advantages-slider .slick-active")[3];
  //   const slide5 = $(".advantages-slider .slick-active")[4];
  //   $(slide1).removeClass('slick-active--1');
  //   $(slide2).removeClass('slick-active--2');
  //   $(slide3).removeClass('slick-active--3');
  //   $(slide4).removeClass('slick-active--2');
  //   $(slide5).removeClass('slick-active--1');
  // });
  
  // $(".advantages-slider").on('afterChange', () => {
  //   const slide1 = $(".advantages-slider .slick-active")[0];
  //   const slide2 = $(".advantages-slider .slick-active")[1];
  //   const slide3 = $(".advantages-slider .slick-active")[2];
  //   const slide4 = $(".advantages-slider .slick-active")[3];
  //   const slide5 = $(".advantages-slider .slick-active")[4];
  //   $(slide1).addClass('slick-active--1');
  //   $(slide2).addClass('slick-active--2');
  //   $(slide3).addClass('slick-active--3');
  //   $(slide4).addClass('slick-active--2');
  //   $(slide5).addClass('slick-active--1');
  // });
};



// WEBPACK FOOTER //
// app/scripts/components/slider.js